// FullPageLoader.jsx
import React, { Component } from "react";
import { ClipLoader } from "react-spinners";

class FullPageLoader extends Component {
  render() {
    return (
      <div style={styles.overlay}>
        <ClipLoader color="#ffffff" size={60} />
      </div>
    );
  }
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.3)", // semi-transparent black
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default FullPageLoader;
